/**
 * 领域模型。
 *
 * 核心约定：**所有部件字段都可以留空**。空值（undefined / 空串 / 非数字）一律视作
 * 「用户未提供该参数」，既不参与计算，也不静默按 0 处理 —— 而是进入 `missing` 列表，
 * 由界面提示「缺少参数“X”，未计入计算」。
 */

export const COMPONENT_KINDS = [
  'frame',
  'motor',
  'esc',
  'propeller',
  'battery',
  'fc',
  'vtx',
  'rx',
  'payload',
  'custom',
] as const;

export type ComponentKind = (typeof COMPONENT_KINDS)[number];

/** 部件分组，用于质量 / 成本的小计与明细展示 */
export const GROUPS = ['airframe', 'power', 'energy', 'avionics', 'payload', 'custom'] as const;

export type GroupId = (typeof GROUPS)[number];

/** 字段值：数字、文本（型号备注）或未填 */
export type FieldValue = number | string | null | undefined;

export interface ComponentInstance {
  id: string;
  kind: ComponentKind;
  /** 数量。4 轴默认 4（电机 / 电调 / 桨）或 1（其余） */
  qty: number;
  /** 自定义部件与载荷可用的显示名 */
  label?: string;
  fields: Record<string, FieldValue>;
}

export interface Project {
  id: string;
  name: string;
  note?: string;
  schemaVersion: 1;
  /** 安全系数：推力预留百分比，默认 20 */
  reservePct: number;
  createdAt: string;
  updatedAt: string;
  components: ComponentInstance[];
}

/** 一个缺失参数的具体位置，用于生成「缺少参数“X”」提示 */
export interface MissingRef {
  componentId: string;
  /** 出现缺失的部件（实例）名称 */
  componentLabel: string;
  fieldKey: string;
  /** 建议直接展示的参数名，例如「电机最大推力」 */
  fieldLabel: string;
  /** 去掉实例差异后的归属，用于汇总去重 */
  metricKey: string;
}
